export default {
  leftNav: {
    nav0: "OVERALL",
    nav1: "FEATURES",
    nav2: "HIGHLIGHTS",
    nav3: "APPLICATIONS",
    nav4: "INFORMATION",
    nav5: "RECOMMENDATIONS",
    nav6: "CONTACT US",
    nav7: "SUPPORT",
  },
  FreeDemo: "Free Demo",
  ContactUs: "Contact us",
  Download: "Download",
  Videos: "Videos",
  accessories: "Accessories",
  similarProducts: "Similar products",
  ContactBrUs: "Contact<br />us",
  DownloadBrCenter: "Download<br />center",
  FAQ: "FAQ",
  ten: {
    Frictionless: "Frictionless <br />Communication",
    Augmented: "Augmented <br />UseExperience",
    Conference: "Conference <br />Anywhere ",
    Enhanced: "Enhanced <br />Speed & Performance",
    Seemless: "Seemless <br />Synchronization",
  },
  message: "Message",
  Oldest: "Oldest",
  Recentness: "Recentness",
  ViewMore: 'View More',
};
